module.exports = __webpack_public_path__ + "assets/8c2223977a14eb97b7b7314184917530.png";